angular.module("registrationModule").component("registrationLookingTo", {
	templateUrl: "registrationLookingTo/registrationLookingTo.html",
	bindings: {
		onTrackStep: "&",
		onSubmitName: "&",
		onClose: "&",
		user: "<",
		errorMessages: "<",
		adDesignEnabled: "<",
	},
	controller: ["$document", "$timeout", "$sce", "$element", "patterns", function($document, $timeout, $sce, $element, patterns) {
		var self = this;

		this.patterns = patterns;
		this.triedToSubmit = false;

		this.formInteractionKeys = [];

		this.$onInit = () => {
			this.checkboxesLookingTo = this.getLookingToCheckboxes();
			$timeout(() => {
				this.form['lookingToBuy'] = true; // default value is looking to buy
			});
		};
		
		this.isLookingToRequired = function() {
			for(let i = 0; i < this.checkboxesLookingTo.length; i++) {
				if (this.checkboxesLookingTo[i].value) {
					return false;
				}
			}
			return true;
		};

		this.submit = function() {
			this.triedToSubmit = true;
			
			if (this.isLookingToRequired()) {
				this.form.$submitted = false;
				angular.forEach(this.formInteractionKeys, (v) => { this.form[v].interacted = false; });
			} else {
				this.form.$submitted = true;
				this.signUp({form: this.form});
			}
		};

		this.signUp = function() {
			if (this.form.$valid) {
				this.onSubmitName({form: this.form});
			} else {
				angular.forEach(this.formInteractionKeys, (v) => { this.form[v].interacted = false; });
			}
		};

		this.getLookingToCheckboxes = function() {
			return [
				{
					id: "lookingToBuy",
					value: true,
					label: "To Buy",
				},
				{
					id: "lookingToRent",
					value: false,
					label: "To Rent",
				},
				{
					id: "lookingToSell",
					value: false,
					label: "To Sell",
				},
				{
					id: "lookingToNeither",
					value: false,
					label: "Other",
				}
			];
		};

		this.toggleValue = function (checkbox) {
			let checkboxes = [...this.checkboxesLookingTo];
			let checkboxToToggle = checkboxes.find(cb => {
				return checkbox.id === cb.id;
			});

			let checkboxesToCycleThrough = [this.checkboxesLookingTo];
			checkboxesToCycleThrough.forEach(function(checkboxesObject) {
				let pos = checkboxesObject.map(function(e) { return e.id; }).indexOf(checkboxToToggle.id);
				if (pos >= 0) {
					checkboxesObject.forEach(function(e) {
						self.form[e.id] = e.value = false;
					});
				}
			});

			checkboxToToggle.value = !checkboxToToggle.value;
			this.form[checkbox.id] = checkbox.value;

		};

		this.$onDestroy = function() {
			$document.off("click", self.closeHandler);
		};

		this.closeHandler = function(e) {
			if ($element !== e.target && !$element[0].contains(e.target)) {
				$timeout(function () { self.onClose();});
			}
		};

		this.fieldChange = function(key) {
			this.form[key].interacted = true;

			if (!this.form[key].$valid) {
				this.form[key].$setValidity(key + "Exist", true);
				this.form[key].$setValidity(key + "Short", true);
				this.form[key].$setValidity(key + "Global", true);
			}

			if (this.form.globalErrors && this.form.globalErrors.length > 0) {
				this.form.globalErrors = [];
			}
		};
	}]
});
